import React from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUserRole } from "./auth";

const RoleRedirect = () => {
  const role = getCurrentUserRole();

  if (role === "host") {
    return <Navigate to="/my-host-logs" replace />;
  }

  if (role === "admin") {
    return <Navigate to="/users" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default RoleRedirect;
